import { Box } from '@coolblue-development/becky';
import { Tooltip } from '@coolblue-development/freddy';
import { Attachment } from '../../../../../../models/Attachment';
import BaseAttachmentChip from '../../BaseAttachmentChip';

// Attachments cannot be removed individually yet (see CSD-3156). Until that ships,
// the chip stays non-removable and this tooltip explains the workaround.
const REMOVE_ATTACHMENT_TOOLTIP = 'To remove the attachment, delete this draft and start a new reply';

interface DraftAttachmentChipsProps {
  attachments: Attachment[];
}

const DraftAttachmentChips = ({ attachments }: DraftAttachmentChipsProps): JSX.Element | null => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '12px'
      }}
      data-testid="attachment-chips-container"
    >
      {attachments.map(attachment => (
        <Tooltip key={attachment.id} description={REMOVE_ATTACHMENT_TOOLTIP} placement="top">
          <span tabIndex={0}>
            <BaseAttachmentChip fileName={attachment.name} dataTestId={`attachment-chip-${attachment.id}`} />
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default DraftAttachmentChips;
